import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable()
export class ImagenCacheBufferService {
  PATH_DOWNLOAD = environment.API_BASE + '/files';

  private imageGuids: Map<string, ArrayBuffer> = new Map();

  constructor(private http: HttpClient) { }

  getImageArrayBufferByGuid(guid: string): Promise<ArrayBuffer> {
    return new Promise<ArrayBuffer>(resolve => {
      if (this.imageGuids.has(guid)) {
        resolve(this.imageGuids.get(guid));
      } else {
        this.imageGuids.set(guid, undefined);
        this.downloadFileByHash(guid).pipe(first()).subscribe((data: ArrayBuffer) => {
          this.imageGuids.set(guid, data);
          resolve(data);
        });
      }
      });
  }

  private downloadFileByHash(guid: string): Observable<ArrayBuffer> {
    return this.http.get(this.PATH_DOWNLOAD + '/' + guid, { responseType: 'arraybuffer' });
  }

}
